/**
 * Lennar brand assets + social row — ported verbatim from the legacy LEN /
 * SOC_KEYS / socDefaults / socRow. Image URLs are the Stensul-hosted brand
 * assets used in production sends.
 */
import { esc } from "./core";
import type { SocialLinks } from "../types/blocks";

export const LEN = {
  base: "https://lennar.stensul.com/images/tenants/lennar/customer/modules/studio//",
  logo: "https://lennar.stensul.com/images/tenants/lennar/customer/modules/studio//6772dcf8eaa9a-1735580920.9612.png",
  logoW:
    "https://lennar.stensul.com/images/tenants/lennar/customer/modules/studio//677c27e400044-1736189924.0001.png",
  flogo:
    "https://lennar.stensul.com/images/tenants/lennar/customer/modules/studio//67acc44eda8dd-1739375694.8952.png",
  soc: [
    ["Facebook", "https://www.facebook.com/lennar", "67c8b56ae48f1-1741206890.9362.png"],
    ["X", "https://x.com/lennar", "67a3cf8a77f88-1738788746.4914.png"],
    ["Instagram", "https://www.instagram.com/lennar", "67a3cf97eb84e-1738788759.9647.png"],
    ["Pinterest", "https://www.pinterest.com/lennar", "67a3cfa64c00d-1738788774.3113.png"],
    ["YouTube", "https://www.youtube.com/lennar", "67a3cfb8d818c-1738788792.8851.png"],
    ["LinkedIn", "https://www.linkedin.com/company/lennar", "67bdcf6457c09-1740492644.3594.png"],
  ] as const,
} as const;

export const SOC_KEYS = ["fb", "x", "ig", "pin", "yt", "li"] as const;

export function socDefaults(): SocialLinks {
  const o = {} as Record<string, string>;
  LEN.soc.forEach((s, i) => {
    o[SOC_KEYS[i]] = s[1];
  });
  return o as unknown as SocialLinks;
}

/**
 * Social icon row. When the block manages its own social keys (the footer
 * does), an EMPTY url means the network is toggled OFF and its icon is
 * dropped; legacy callers still get all defaults. In production the division's
 * REAL links fill these via /sfmc-social-links (Dynamic mode).
 */
export function socRow(d?: Partial<SocialLinks>): string {
  const data: Partial<Record<string, string>> = (d as Record<string, string>) || {};
  const managed = SOC_KEYS.some((kk) => data[kk] != null);
  return LEN.soc
    .map((s, i) => {
      const raw = data[SOC_KEYS[i]];
      if (managed && (raw == null || String(raw).trim() === "")) return "";
      const u = raw != null && raw !== "" ? raw : s[1];
      return (
        '<a href="' +
        esc(u) +
        '" target="_blank" style="text-decoration:none"><img src="' +
        LEN.base +
        s[2] +
        '" alt="' +
        s[0] +
        '" width="24" height="24" style="display:inline-block;height:24px;width:24px;margin:0 6px"></a>'
      );
    })
    .join("");
}
